import React from "react";
import Formulario from "./Formulario";
import Tabela from "./Tabela";
import useRenderFormStore from "../stores/useRenderFormStore";
import { useHistory } from "react-router";
import EditFormulario from "./EditFormulario";

const HabilitarDiagnostico = () => {
  const { showForm } = useRenderFormStore();
  const history = useHistory();

  const isEdit = history.location.pathname.includes("/edit");

  return showForm ? isEdit ? <EditFormulario /> : <Formulario /> : <Tabela />;
};

export default HabilitarDiagnostico;
